(() => {
  if (window.variantSpecTableInitialized) return;
  window.variantSpecTableInitialized = true;

  const ROOT_SELECTOR = '[data-variant-spec-table-section-id]';

  // カート追加後の通知。
  // 以前はここでヘッダーのバッジDOMを直接書き換えていたが、EC-CUBE版デザインの
  // バッジ(.ec-cartNavi__badge)と二重表示になる不具合があったため、Dawn標準の
  // PUB_SUB_EVENTS.cartUpdateイベントを発行するだけにした。実際のバッジ更新は
  // assets/theme.js側の購読処理(handleCartUpdate)に一本化している。
  async function notifyCartUpdate() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'variant-spec-table', cartData: cart });
      }
    } catch (error) {
      console.warn('Cart state refresh failed.', error);
    }
  }

  function openModal(root, message) {
    const modal = root.querySelector('[data-variant-spec-modal]');
    const messageNode = root.querySelector('[data-variant-spec-modal-message]');
    if (!modal) return;

    if (messageNode) messageNode.textContent = message || '';
    modal.hidden = false;
    document.body.classList.add('variant-spec-modal-open');

    const closeButton = modal.querySelector('.variant-spec-modal__close');
    if (closeButton) closeButton.focus();
  }

  function closeModal(root) {
    const modal = root.querySelector('[data-variant-spec-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('variant-spec-modal-open');
  }

  function setFeedback(root, message, isError) {
    const feedback = root.querySelector('[data-variant-spec-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.classList.toggle('is-error', Boolean(isError));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const root = form.closest(ROOT_SELECTOR);
    if (!root) return;

    const submitButton = form.querySelector('[data-variant-spec-submit]');

    // 【重要】ここで `form.id` を使ってはいけません。
    // このフォームには Shopify のバリアント指定に必須の <input name="id"> が含まれており、
    // form要素が内包する入力欄を name でプロパティ公開する仕様（named property）により、
    // `form.id` はフォームのid属性値ではなく、その input要素自身を指してしまいます。
    // その結果セレクタが一致せず、数量が常に1になる不具合が発生していました。
    // 必ず getAttribute('id') で取得してください。
    const formId = form.getAttribute('id');
    const quantityInput =
      form.querySelector('[data-variant-spec-qty]') ||
      (formId ? root.querySelector(`[data-variant-spec-qty][form="${CSS.escape(formId)}"]`) : null);
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    const variantTitle = submitButton?.dataset.variantTitle || '商品';

    const formData = new FormData(form);
    formData.set('quantity', String(quantity));

    if (submitButton) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
    }
    setFeedback(root, '', false);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || result.message || 'カート追加に失敗しました。');
      }

      openModal(root, `${variantTitle} / ${quantity}点 をカートに追加しました。`);
      await notifyCartUpdate();
    } catch (error) {
      console.error(error);
      setFeedback(root, error.message || 'カート追加に失敗しました。', true);
    } finally {
      if (submitButton) {
        submitButton.removeAttribute('aria-busy');
        submitButton.disabled = false;
      }
    }
  }

  function setupRoot(root) {
    if (root.dataset.variantSpecTableBound === 'true') return;
    root.dataset.variantSpecTableBound = 'true';

    root.querySelectorAll('[data-variant-spec-form]').forEach((form) => {
      form.addEventListener('submit', handleSubmit);
    });

    root.querySelectorAll('[data-variant-spec-close]').forEach((element) => {
      element.addEventListener('click', () => closeModal(root));
    });
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(setupRoot);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => closeModal(root));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
